import { createContext, useContext } from "react";
import {
  Milestone,
  PROGRESS_BAR_TYPE,
  MilestoneCategory,
  Customizations,
} from "./types";

export interface ProgressBarContext {
  milestones: Milestone[];
  total: number;
  achievedMilestoneIdx: number;
  totalMilestones: number;
  currentProgress: number;
  customizations: Customizations;
  onMilestoneReached?: (milestone: Milestone) => void;
}

const ProgressContext = createContext<ProgressBarContext>({
  milestones: [],
  total: 0,
  achievedMilestoneIdx: 0,
  totalMilestones: 0,
  currentProgress: 0,
  customizations: {
    type: PROGRESS_BAR_TYPE.DYNAMIC,
    category: MilestoneCategory.PRICE_BASED,
    completedMessage: "",
    completedMessage_enabled: false,
    textonProgressBar_header: false,
    textonProgressBar_amount: false,
    textonProgressBar_title: false,
    textonProgressBar_headerColor: "#2c874a",
    textonProgressBar_amountColor: "#2c874a",
    textonProgressBar_titleColor: "#2c874a",
    filledColor: "#2c874a",
    backgroundColor: "#2c874a",
  },
});

interface ProgressBarProviderProps extends ProgressBarContext {
  children: React.ReactNode;
}

export const ProgressBarProvider = ({
  children,
  milestones,
  achievedMilestoneIdx = 1,
  totalMilestones,
  currentProgress,
  total,
  customizations,
  onMilestoneReached,
}: ProgressBarProviderProps) => {
  return (
    <ProgressContext.Provider
      value={{
        achievedMilestoneIdx,
        totalMilestones,
        currentProgress,
        milestones,
        total,
        customizations,
        onMilestoneReached,
      }}
    >
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgressBar = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error("useProgressBar must be used within a ProgressBarProvider");
  }
  return context;
};
